export default __webpack_public_path__ + "static/media/owner2-illustration.dadbdf20.svg";